<template>
  <el-dialog
    :title="$t('editAffiliateProduct.title')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('editAffiliateProduct.product')" prop="productId">
        <el-input
          v-model="form.productId"
          :placeholder="$t('editAffiliateProduct.productPlaceholder')"
          disabled
        />
      </el-form-item>
      <el-form-item :label="$t('editAffiliateProduct.seq')" prop="seq">
        <el-input
          v-model="form.seq"
          :placeholder="$t('editAffiliateProduct.seqPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateAffiliateProduct } from '@/api/affiliate/affiliateProductApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditAffiliateProduct',
  data() {
    return {
      dialogVisible: false,
      form: {
        apId: '',
        productId: '',
        seq: '',
        shopId: ''
      },
      rules: {
        productId: [
          { required: true, message: this.$t('editAffiliateProduct.productRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('editAffiliateProduct.productMaxLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('editAffiliateProduct.seqRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('editAffiliateProduct.seqPattern'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.form = {
        apId: row.apId,
        productId: row.productId,
        seq: row.seq,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await updateAffiliateProduct(this.form)
            this.$message.success(this.$t('editAffiliateProduct.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>